import { fn } from '@common/utils';
import { DialogService } from '@services/dialogservice';
import { IPageProperty } from '../../nav';
import { NavPageItems, NavPageItem, NavItemAnchor } from '../../navdata/navdata';
import { NavItemsGrid, INavItemsGridOptions, Bind as kBind } from '../../navkendo';
import * as rwf3 from '@common/rwf';
import { NavSettingsService } from '@common/services/settingsservice';
import { SessionEvents } from '@common/rwf/rwfedit.common';
import { FDRW_Auftragsbuchblatt, FDRW_Anordnungsblatt, ROWMETHOD } from '@common/rwf/rwf.const';
import { Observable } from '../../navdata/navdata';
import { RWF3BaseService } from '../rwf3baseservice';
import { CompatibilityService } from '@services/compatibilityservice';
import { $ModalClose } from '@common/services/DialogService';
import { GetGridOptionSettings } from '@common/navkendo';

/** Event Name for Current Item Changed */
const CurrentItemChanged = "CurrentItemChanged";
const CloseHuelAction = "CloseHuelAction";
/** Dialog Huel Aufteilung Controller */
export class CtrlHuelaufteilung extends Observable {
    static Template = require("./huelaufteilung.html");
    /** HuelAufteilung UI as Directive */
    static Directive = [function (): ng.IDirective {
        return {
            controller: CtrlHuelaufteilung,
            controllerAs: "vm",
            template: CtrlHuelaufteilung.Template,
            scope: {
                service: "=service"
            }
        };
    }];
    /** Show HuuelAufteilung Dialog */
    public static ShowModal(this: void, $c: CompatibilityService, svc: RWF3BaseService) {
        const dlg = $c.resolve("DialogService");
        let ctrl: CtrlHuelaufteilung;
        return dlg.ShowWindow({
            windowOptions: { modal: true, width: "80%", title: "HUEL Aufteilung", open: e => { if (!ctrl) e.preventDefault(); } },
            controller: CtrlHuelaufteilung,
            controllerAs: "vm",
            template: CtrlHuelaufteilung.Template,
        }).then(w => {
            ctrl = w.controller;
            w.scope.$on(CloseHuelAction, () => w.window.close());
            ctrl.SetService(svc, true, true).then(() => w.window.open(), err => dlg.ShowError(err));
        });
    }
    private getItemsGrid = () => <NavItemsGrid>this.$scope["huelGrid"];
    private get CurrentItems() { return this.service && this.service.HuelState.Current; }
    private get AllowEdit() {
        if (this.allowEdit === false)
            return false;
        return this.service && !this.service.Session.NoEdit;
    }
    private allowEdit: boolean;
    private readonly isDialog: boolean;

    public get IsInOperation() {
        if (this._lastOp)
            return true;
        var items = this.CurrentItems;
        if (items && items.Anchor.InOperation)
            return true;
        let session = this.service && this.service.Session;
        return session && session.IsInOperation;
    }
    static $inject = ["$scope", "CompatibilityService", "DialogService", "NavSettings"];
    constructor(
        private $scope: ng.IScope & { service: RWF3BaseService, Items: NavPageItems },
        private $c: CompatibilityService,
        private dlg: DialogService,
        private NavSettings: NavSettingsService
    ) {
        super();
        let me = this,
            isDialog = this.isDialog = !$scope.service;

        Object.defineProperty($scope, "IsInOperation", {
            get: () => {
                if (this._lastOp)
                    return true;
                var items = this.CurrentItems;
                if (items && items.Anchor.InOperation)
                    return true;
                let session = this.service && this.service.Session;
                return session && session.IsInOperation;
            }
        });

        $scope.$on("$destroy", () => this.SetService(undefined, false));
        var doEZHMethod = (methName: string, confirmMessage?: string) => () => {
            return $c.when(!confirmMessage || dlg.ShowConfirm(confirmMessage)).then(exec => {
                if (!exec)
                    return;
                return this.service.Session.DisplayItem.ExecuteMethod({ MethodName: methName }, null, true).then(
                    () => this.CurrentItems.RevertItem(true)).then(refreshActions, refreshActions);
            });
        },
            closeAction = () => $scope.$emit(CloseHuelAction);

        var huelActions = $scope["HUELActions"] = {
            Insert: {
                Enabled: false,
                Execute: doEZHMethod("InsertNewDistributionLine")
            },
            Reset: {
                Enabled: false,
                Execute: doEZHMethod("ResetDistribution", "Möchten Sie die Erfassungszeile HÜL neu Aufteilen?")
            },
            DeleteLine: {
                Enabled: false,
                Execute: () => {
                    var items = this.CurrentItems;
                    if (items.SelectedIds.length == 0)
                        throw new Error("Keine Zeile gewählt");
                    return dlg.WhenConfirm("Zeile(n) löschen?").then(() => items.Anchor.EnqueueOperation(() => items.DeleteItems(items.SelectedIds)));
                }
            },
            Delete: {
                Enabled: false,
                Execute: () => doEZHMethod("DiscardDistribution", "Möchten Sie die Aufteilung der Erfassungszeile HÜL verwerfen?")().then(closeAction)
            },

            Create: {
                Hidden: isDialog,
                Enabled: false,
                Execute: () => this.RefreshCurrentItem(true)
            },

            Close: {
                Hidden: !isDialog,
                Execute: () => $c.when(this.uiValidate(true)).then(closeAction)
            }
        };

        function refreshActions(this: void) {
            let items = me.CurrentItems,
                allowEdit = me.AllowEdit;
            huelActions.Insert.Enabled = huelActions.Reset.Enabled = huelActions.DeleteLine.Enabled = me.AllowEdit && !!items;
            huelActions.Delete.Enabled = allowEdit && items && items.Count > 0;
            huelActions.Create.Enabled = allowEdit && (!items || items.Count == 0);
            huelActions.Reset.Enabled = allowEdit && items && items.Count > 0;
        }
        this.bind(CurrentItemChanged, refreshActions);

        var initialService = $scope.service;
        if (initialService)
            this.SetService(initialService, false, false);
    };

    public SetService(service: RWF3BaseService, withCreate: boolean, allowEdit?: boolean) {
        let $scope = this.$scope,
            ServiceChanged = "ServiceChanged";

        if (allowEdit !== undefined)
            this.allowEdit = allowEdit;

        // avoid circular dependenices
        // service = (service instanceof RWF3KAMService && service) || undefined;
        service = service && service.HuelState && service;

        if (service !== this.service) {
            this.service = service;

            // set Grid Options from Available Client Info if not yet done
            if (!$scope["gridOptions"] && service?.HuelState?.HuelClient) {
                let gridOptions = <INavItemsGridOptions>{ Source: service.HuelState.HuelClient, Readonly: !this.AllowEdit };
                if (this.isDialog) { // TODO : Find Cleaner Way ...
                    const settings = this.NavSettings.CreateUserSettings(["KWF", "DlgHuelAufteilung"]);
                    $scope.$on($ModalClose, () => settings.Save());
                    var lSettings: any;
                    gridOptions.EditContext = {
                        AddSetting: (name, s) => {
                            if (lSettings && lSettings[name])
                                s.apply(lSettings[name]);
                            return settings.Add(name, s);
                        },
                        AddDispose: (s) => $scope.$on($ModalClose, s),
                        GetAttachedParent: fn.nullOp
                    };
                    const afterLoad = () => { $scope["gridOptions"] = gridOptions; };
                    settings.ForceLoaded().then(s => { lSettings = s; }).then(afterLoad, afterLoad);

                } else {
                    $scope["gridOptions"] = gridOptions;
                    service.Session?.UserSettings.Add("HuelGrid", GetGridOptionSettings(gridOptions.baseOptions, () => this.getItemsGrid()));
                }
            }

            this.trigger(ServiceChanged);

            let session = service && service.Session;
            if (session) {
                let refresh = fn.proxy(this.RefreshCurrentItem, this, false);
                this.one(ServiceChanged, kBind(session, refresh, SessionEvents.displaychange));

                // Refresh own State on external Change
                var extSetItems = (e: { Source: CtrlHuelaufteilung, Items: NavPageItems, Huel_ZeilenNr: number }) => {
                    if (e && e.Source && e.Source !== this && $scope.Items !== e.Items)
                        this.setItems(e.Items, this.service, e.Huel_ZeilenNr);
                };
                this.one(ServiceChanged, kBind(service.HuelState, extSetItems, CurrentItemChanged));
            }
            return this.RefreshCurrentItem(withCreate);
        }
    }
    private service: RWF3BaseService;
    private RefreshCurrentItem(withCreate?: boolean) {
        let service = this.service,
            items: NavPageItems,
            huel: number;
        var result = this._lastOp = this.$c.finally(this.GetHuelAufteilung(withCreate).then(Items => {
            items = (Items && Items.Items);
            huel = Items && Items.HÜL_Zeilennr;
        }), () => {
            if (result == this._lastOp) {
                delete this._lastOp;
                this.setItems(items, service, huel);
            }
        });
        return result;
    }
    private _lastOp: PromiseLike<any>;

    private setItems(items: NavPageItems, service: RWF3BaseService, Huel_ZeilenNr: number) {
        items = items instanceof NavPageItems ? items : undefined;
        var $scope = this.$scope;

        $scope.Items = items;
        var huel = service && service.HuelState;
        if (huel && huel.Current !== items) {
            huel.Current = items;
            let setTitle = () => {
                let hCount = items && items.Count;
                huel.Title = "Huel Aufteilung" + (hCount > 0 ? " (" + hCount + ")" : "");
            };
            huel.trigger(CurrentItemChanged, { Source: this, Items: items, Huel_ZeilenNr: Huel_ZeilenNr });
            if (items) {
                huel.one(CurrentItemChanged, items.RegisterCountChanged(setTitle));
            } else {
                setTitle();
            }
        }

        var grid = this.getItemsGrid();
        if (grid) {
            grid.SetItems(items);
            if (Huel_ZeilenNr) {
                const filter = <kendo.data.DataSourceFilterItem>{ field: "HÜL_Zeilennr", value: Huel_ZeilenNr };
                grid.dataSource.filter([filter]);
            } else {
                grid.dataSource.filter([]);
            }
        }
        this.trigger(CurrentItemChanged);

        if (items) {
            if (items.SelectionCount == 0 && items.Count > 0)
                items.SetSelected(items.GetItems(0));
        }

        // Ensure Refresh of Huel Data on Change of some Props on Parent Item
        let source = this.service && this.service.Session.DisplayItem,
            propNames = ["HUEL_Aufteilung_vorhanden", "Betrag", "Buchungsdatum"],
            props: IPageProperty[];
        if (source && (props = propNames.map(name => source.MetaData.PropsByName[name]).filter(fn.isSet)).length > 0) {
            this.one(CurrentItemChanged, source.RegisterPropertyChanged(props, (ev) => ev.Item == source && this.RefreshCurrentItem()));
        }
    }
    /** Read HuelAufteilung for Item, CAUTION/ : Mandatory/ReadonlyState gets hard initialized with current Forms State, gets refresh for Current! */
    private GetHuelAufteilung(withCreate: boolean) {
        let service = this.service,
            itemEZH = service && <NavPageItem<rwf3.FDRW_Auftragsbuchblatt | rwf3.FDRW_Anordnungsblatt>>service.Session.DisplayItem,
            pageName = itemEZH && itemEZH.PageName;
        let result = {
            Items: <NavPageItems<rwf3.IFDRW_HuelAufteilung>>undefined,
            HÜL_Zeilennr: <number>undefined
        };
        if (pageName != FDRW_Auftragsbuchblatt && pageName != FDRW_Anordnungsblatt) {
            return this.$c.when(result);
        }
        let getHuelValue = (name: keyof (rwf3.IFDRW_Auftragsbuchblatt & rwf3.IFDRW_Anordnungsblatt)) => itemEZH.GetValue(<any>name, true),
            // Prepare Huel only if allowEdit
            wfStep = service && service.CurrWFStep,
            viewIsLocked = wfStep && wfStep.ViewType == rwf3.ViewType.Locked,
            resolveDistLocked = wfStep && (wfStep.ResolveDistributionLocked != viewIsLocked),
            prepareHuel = withCreate && this.AllowEdit && !resolveDistLocked && itemEZH && itemEZH.ExecuteMethod({ MethodName: ROWMETHOD.ResolveDistribution }, null, true);

        return this.$c.when(prepareHuel).then(() => itemEZH && itemEZH.Service.LoadPageItems<"FDRW_HuelAufteilung">({
            PageName: "FDRW_HuelAufteilung",
            InstanceID: itemEZH.Anchor.InstanceID,
            Constraints: [
                { FieldName: "DokID", Value: <any>getHuelValue("DokID") },
                // Do fetch all and filter on client for SWU - Sync Storage functionality to work! { FieldName: "HÜL_Zeilennr", Value: getHuelValue(pageName == FDRW_Auftragsbuchblatt ? "Lfd_Nr" : "Zeilennr") }
            ], PageCount: 0
        }, itemEZH.ClientInfo)).then(items => {
            if (service && items) {
                let anchor = items.Anchor;
                if (service.IsStandalone) {
                    items.Anchor.Readonly.SetForceAll(true);
                }
                var fieldInfo = service.HuelState.HuelFields;
                // Apply Mandatory and Readonly State from Current Config (as long as usage is in Modal UI this is OK
                if (fieldInfo) {
                    anchor.Mandatory.ReplaceValues("HUEL", fieldInfo.Mandatory || []);
                    anchor.Readonly.ReplaceValues("HUEL", fieldInfo.Locked || []);
                }
            }
            result = {
                Items: items,
                HÜL_Zeilennr: <number>getHuelValue(pageName == FDRW_Auftragsbuchblatt ? "Lfd_Nr" : "Zeilennr")
            };
            return result;
        });
    }

    private uiValidate(isClose: boolean) {
        var Items = this.CurrentItems,
            $c = this.$c,
            dlg = this.dlg,
            invalidProp = Items && Items.Anchor.FindFirstInvalid();

        if (!invalidProp)
            return $c.when();

        let prop = invalidProp.Prop;
        var mesage = "Das Feld '" + prop.Title + "' muss gefüllt werden!" + (isClose ? "\n Trotzdem Schliessen?" : "");
        return (isClose ? dlg.ShowConfirm(mesage) : dlg.ShowError(mesage).then(fn.ToFunc(false))).then(isClose => {
            if (!isClose) {
                var grid = this.getItemsGrid();
                if (grid) {
                    grid.editCellById(invalidProp.Item.Model["uid"], prop.Name);
                }
                fn.error.ThrowCancel();
            }
        });
    }
}
